import { render, staticRenderFns } from "./Siderbar.vue?vue&type=template&id=1613704b&scoped=true&"
import script from "./Siderbar.vue?vue&type=script&lang=js&"
export * from "./Siderbar.vue?vue&type=script&lang=js&"
import style0 from "./Siderbar.vue?vue&type=style&index=0&id=1613704b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../wxpush/sources/client/wxpush-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1613704b",
  null
  
)

export default component.exports